import ReturnsNullOn404 from "common/http/returnsNullOn404";
import OrderThin from "domain/orderThin";
import AdminHttpService from "admin/common/adminHttpService";

class OrderService extends AdminHttpService {

    @ReturnsNullOn404()
    async getWorkingOrders(merchantId: string, fcmAccount: string): Promise<OrderThin[]> {
        const response = await this.getClient(merchantId).get('/offers/v1/orders/working-orders', {
            params: { fcmAccount }
        });
        return response.data;
    }
}

const orderService = new OrderService();
export default orderService;